import { useEffect } from 'react';

// rescanKey is any value whose change means new tweet markup may be in #content-blocks.
const useRenderTwitterEmbeds = (slug: string, rescanKey: unknown) => {
  useEffect(() => {
    const content = document.getElementById('content-blocks');
    window.twttr?.widgets?.load(content);
  }, [slug, rescanKey]);
};

export default useRenderTwitterEmbeds;
